<template>
  <div class="bg-color-dynamic">
    <!-- Impact Section -->
    <!-- gede aja -->
    <section class="d-block page-section bg-color-dynamic" id="impactsection">
      <div class="container">

        <div class="impact-wrapper flex-column flex-lg-row">
          <div class="impact-column">
            <!-- TOTAL USAGE MINUTES -->
            <div v-if="dataCurrentActiveProductTab == 'qtv'" class="d-flex flex-row justify-content-end" style="column-gap: 1rem;">
              <div class="d-flex flex-column justify-content-center align-items-end">
                <img v-lazy="imgObjClock" alt="icon-users-mini" class="icon-users tinted-dynamic-color" />
                <span v-lazy:background-image="imgObjClock"></span>
              </div>
              <div class="d-flex flex-column text-impact-wrapper">
                <h1 class="text-white mt-0 font-weight-bold roboto-font title-impact tinted-dynamic-color">
                  <ImpactNumber
                    ref="numberUsageMinutes"
                    :tab="'usage'"
                    :numberFrom="0"
                    :numberTo="fetched ? totalUsageMinutes[dataCurrentActiveProductTab] : 0"
                    :fractionDigits="0"
                    />
                </h1>
                <span class="text-white mt-0 roboto-font text-impact-desc tinted-dynamic-color" v-t="{path: 'impactMinutesUsage'}"></span>
              </div>
            </div>
            <!-- USERS -->
            <div v-else class="d-flex flex-row justify-content-end" style="column-gap: 1rem;">
              <div class="d-flex flex-column justify-content-center align-items-end">
                <img v-lazy="imgObjUsers" alt="icon-users-mini" class="icon-users tinted-dynamic-color" />
                <span v-lazy:background-image="imgObjUsers"></span>
              </div>
              <div class="d-flex flex-column text-impact-wrapper">
                <h1 class="text-white mt-0 font-weight-bold roboto-font title-impact tinted-dynamic-color">
                  <ImpactNumber
                    ref="numberUsers"
                    :tab="'users'"
                    :numberFrom="0"
                    :numberTo="fetched ? totalUsers[dataCurrentActiveProductTab] : 0"
                    :fractionDigits="0"
                    />
                </h1>
                <span class="text-white mt-0 roboto-font text-impact-desc tinted-dynamic-color" v-t="{path: 'impactUsers'}"></span>
              </div>
            </div>
            <!-- GOOGLE PLAY STORE - LANDSCAPE -->
            <div v-if="dataCurrentActiveProductTab != 'qtv'" class="d-none d-lg-flex flex-row justify-content-end" style="column-gap: 1rem;">
              <div class="d-flex flex-column justify-content-center align-items-end">
                <img v-lazy="imgObjStar" alt="icon-users-mini" class="icon-users tinted-dynamic-color" />
                <span v-lazy:background-image="imgObjStar"></span>
              </div>
              <div class="d-flex flex-column text-impact-wrapper">
                <h1 class="text-white mt-0 font-weight-bold roboto-font title-impact tinted-dynamic-color">
                  <ImpactNumber
                    ref="numberPlayStoreLandscape"
                    :tab="'playstore-landscape'"
                    :numberFrom="0"
                    :numberTo="fetched ? totalStars.playstore[dataCurrentActiveProductTab] : 0"
                    :fractionDigits="1"
                    />
                </h1>
                <span class="text-white mt-0 roboto-font text-impact-desc tinted-dynamic-color">
                    GOOGLE PLAY STORE
                </span>
              </div>
            </div>
          </div>
          <div class="impact-column">
            <!-- COUNTRIES -->
            <div class="d-flex flex-row justify-content-end" style="column-gap: 1rem;">
              <div class="d-flex flex-column justify-content-center align-items-end">                
                <img v-lazy="imgObjCountries" alt="icon-maps" class="icon-users tinted-dynamic-color" />
                <span v-lazy:background-image="imgObjCountries"></span>
              </div>
              <div class="d-flex flex-column text-impact-wrapper">
                <h1 class="text-white mt-0 font-weight-bold roboto-font title-impact tinted-dynamic-color">
                  <ImpactNumber
                    ref="numberCountries"
                    :tab="'countries'"
                    :numberFrom="0"
                    :numberTo="fetched ? totalCountries[dataCurrentActiveProductTab] : 0"
                    :fractionDigits="0"
                    />
                </h1>
                <span class="text-white mt-0 roboto-font text-impact-desc tinted-dynamic-color">
                  {{ $t('impactCountries') }}
                </span>
              </div>
            </div>
            <!-- GOOGLE PLAY STORE - POTRAIT -->
            <div class="d-flex d-lg-none flex-row justify-content-end" style="column-gap: 1rem;">
              <div class="d-flex flex-column justify-content-center align-items-end">
                <img v-lazy="imgObjStar" alt="icon-users-mini" class="icon-users tinted-dynamic-color" />
                <span v-lazy:background-image="imgObjStar"></span>
              </div>
              <div class="d-flex flex-column text-impact-wrapper">
                <h1 class="text-white mt-0 font-weight-bold roboto-font title-impact tinted-dynamic-color">
                  <ImpactNumber
                    ref="numberPlayStorePotrait"
                    :tab="'playstore-potrait'"
                    :numberFrom="0"
                    :numberTo="fetched ? totalStars.playstore[dataCurrentActiveProductTab] : 0"
                    :fractionDigits="1"
                    />
                </h1>
                <span class="text-white mt-0 roboto-font text-impact-desc tinted-dynamic-color">
                    GOOGLE PLAY STORE
                </span>
              </div>
            </div>
            <!-- APPLE APP STORE -->
            <div v-if="dataCurrentActiveProductTab != 'qtv'" class="d-flex flex-row justify-content-end" style="column-gap: 1rem;">
              <div class="d-flex flex-column justify-content-center align-items-end">
                <img v-lazy="imgObjStar" alt="icon-maps" class="icon-users tinted-dynamic-color" />
                <span v-lazy:background-image="imgObjStar"></span>
              </div>
              <div class="d-flex flex-column text-impact-wrapper">
                <h1 class="text-white mt-0 font-weight-bold roboto-font title-impact tinted-dynamic-color">
                  <ImpactNumber
                    ref="numberAppStore"
                    :tab="'appstore'"
                    :numberFrom="0"
                    :numberTo="fetched ? totalStars.appstore[dataCurrentActiveProductTab] : 0"
                    :fractionDigits="1"
                    />
                </h1>
                <span class="text-white mt-0 roboto-font text-impact-desc tinted-dynamic-color">
                    APPLE APP STORE
                </span>
              </div>
            </div>
          </div>
        </div>
        <!-- GOOGLE PLAY STORE - QTV ONLY -->
        <div v-if="dataCurrentActiveProductTab == 'qtv'" class="d-none d-lg-flex impact-wrapper flex-column flex-lg-row" style="padding-bottom: 0;">
          <div class="d-flex mt-1 flex-row justify-content-end justify-content-lg-center" style="column-gap: 1rem;">
            <div class="d-flex flex-column justify-content-center align-items-end">
              <img v-lazy="imgObjStar" alt="icon-maps" class="icon-users tinted-dynamic-color" />
              <span v-lazy:background-image="imgObjStar"></span>
            </div>
            <div class="d-flex flex-column text-impact-wrapper text-impact-qtv-wrapper">
              <h1 class="text-white mt-0 font-weight-bold roboto-font title-impact tinted-dynamic-color">
                <ImpactNumber
                  ref="numberPlayStoreQtv"
                  :tab="'playstore-qtv'"
                  :numberFrom="0"
                  :numberTo="fetched ? totalStars.playstore[dataCurrentActiveProductTab] : 0"
                  :fractionDigits="1"
                  />
              </h1>
              <span class="text-white mt-0 roboto-font text-impact-desc tinted-dynamic-color">
                  GOOGLE PLAY STORE
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { setTimeout } from 'timers';
import * as constants from '@/constants';
import { createImageObject } from '@/utils/utils';
import lazyLoadComponent from '../utils/lazy-load-component';
import SkeletonLoading from './utils/SkeletonLoading';

const defaultOptions = {
  loading: SkeletonLoading,
  loadingData: {
    props: {
      width: `100%`,
      height: `20em`,
    },
  },
};
export default {
  name: 'ImpactSection',
  components: {
    ImpactNumber: lazyLoadComponent({
      ...defaultOptions,
      componentFactory: () => import(`./ImpactNumber.vue`),
    }),
  },
  data() {
    return {
      imgObjUsers: createImageObject('./assets/img/impacts/users.svg'),
      imgObjCountries: createImageObject('./assets/img/impacts/countries.svg'),
      imgObjClock: createImageObject('./assets/img/impacts/clock.svg'),
      imgObjStar: createImageObject('./assets/img/impacts/starv2.svg'),
      fetched: false,
      totalUsers: {},
      totalCountries: {},
      totalStars: {appstore: {}, playstore: {}},
      totalUsageMinutes: {},
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.fetchImpacts();
      // alert('impact section finish loaded')
      this.$emit('isAwardSection', 'awardSectionActive')
    });
  },
  props: {
    dataCurrentActiveProductTab: String
  },
  watch: {
    dataCurrentActiveProductTab: function (val) {
      if (this.fetched) {
        this.$nextTick(() => {
          this.playNumberAnimation();
        })
      }
    },
  },
  methods: {
    fetchImpacts() {
      this.$http.get(`${constants.baseUrl}/total-impacts`)
        .then(response => {
          // Extract the data array (guard against a missing/malformed payload)
          const data = (response && response.data && Array.isArray(response.data.data))
            ? response.data.data
            : [];

          data.forEach(item => {
            if (!isNaN(item.value)) {
              item.value = Number(item.value);
            }

            // Total Users
            if (item.type === constants.users_lqtajwid) {
              this.totalUsers[constants.lqtajwid] = item.value;
            }
            else if (item.type === constants.users_lqtafsir) {
              this.totalUsers[constants.lqtafsir] = item.value;
            }
            else if (item.type === constants.countries_lqtajwid) {
              this.totalCountries[constants.lqtajwid] = item.value;
            }
            // Total Countries
            else if (item.type === constants.countries_lqtafsir) {
              this.totalCountries[constants.lqtafsir] = item.value;
            }
            else if (item.type === constants.countries_qtv) {
              this.totalCountries[constants.qtv] = item.value;
            }
            // Total Stars
            else if (item.type === constants.star_rating_google_play_store_lqtajwid) {
              this.totalStars.playstore[constants.lqtajwid] = item.value;
            }
            else if (item.type === constants.star_rating_google_play_store_lqtafsir) {
              this.totalStars.playstore[constants.lqtafsir] = item.value;
            }
            else if (item.type === constants.star_rating_google_play_store_qtv) {
              this.totalStars.playstore[constants.qtv] = item.value;
            }
            else if (item.type === constants.star_rating_apple_app_store_lqtajwid) {
              this.totalStars.appstore[constants.lqtajwid] = item.value;
            }
            else if (item.type === constants.star_rating_apple_app_store_lqtafsir) {
              this.totalStars.appstore[constants.lqtafsir] = item.value;
            }
            // Total Usage Minutes
            else if (item.type === constants.minutes_of_usage_qtv) {
              this.totalUsageMinutes[constants.qtv] = item.value;
            }
          });

          this.fetched = true;
          this.playNumberAnimation();
        })
        .catch(error => {
            console.error('Error when fetching impact', error);
        })
    },
    playNumberAnimation() {
      if (this.$refs.numberUsageMinutes) {
        this.$refs.numberUsageMinutes.play();
      }
      if (this.$refs.numberUsers) {
        this.$refs.numberUsers.play();
      }
      if (this.$refs.numberPlayStoreLandscape) {
        this.$refs.numberPlayStoreLandscape.play();
      }
      if (this.$refs.numberCountries) {
        this.$refs.numberCountries.play();
      }
      if (this.$refs.numberPlayStorePotrait) {
        this.$refs.numberPlayStorePotrait.play();
      }
      if (this.$refs.numberAppStore) {
        this.$refs.numberAppStore.play();
      }
      if (this.$refs.numberPlayStoreQtv) {
        this.$refs.numberPlayStoreQtv.play();
      }
    },
  },
  created() {

  }
}
</script>

<style scoped>

.tinted-dynamic-color {
  --image-filter-tinted-dynamic-color: brightness(0) saturate(100%) invert(17%) sepia(100%) saturate(400%) hue-rotate(143deg) brightness(94%) contrast(95%);

  filter: var(--image-filter-tinted-dynamic-color) !important;
}

body.dark .tinted-dynamic-color {
  --image-filter-tinted-dynamic-color: brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(100%) contrast(100%);
}

body.force-dark .tinted-dynamic-color {
  --image-filter-tinted-dynamic-color: brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(100%) contrast(100%);
}

.bg-color-dynamic {
    --afterclick-bg-color: white;
    background-color: var(--afterclick-bg-color) !important;

}
body.dark .bg-color-dynamic {
  --afterclick-bg-color: #022534!important;
}

body.force-dark .bg-color-dynamic {
  --afterclick-bg-color: #022534!important;
}

.bg-lq-dark-blue {
  background-color: #053448;
}

.roboto-font {
  text-align: center;
  font-family: 'RobotoLight', 'Rubik', sans-serif !important;
  font-weight: 300 !important;
  color: #053448 !important;  /* dark blue color LQ */
  /* color: #ff7000 !important; --> orange color LQ */
}

.text-impact {
  font-size: 1rem;
  text-align: left;
}

.icon-users {
  /* max-height: 90%;
    max-width: 100%; */
  height: 3.5rem;
  filter: brightness(0) saturate(100%) invert(15%) sepia(53%) saturate(1820%) hue-rotate(159deg) brightness(94%) contrast(91%);
}

/* if kecil aja */
.title-impact-mini {
  font-size: 2rem;
  text-align: left !important;
}

.text-impact-mini {
  font-size: 0.78rem;
  text-align: left !important;
}

.col-icon-users-mini {
  text-align: right;
  padding-right: 0;
}

.icon-users-mini {
  /* max-height: 75%;
    max-width: 100%; */
  max-width: fit-content;
  max-height: 3.5rem;
  /* filter: brightness(0) saturate(100%) invert(15%) sepia(53%) saturate(1820%) hue-rotate(159deg) brightness(94%) contrast(91%); */
}

.col-icon-maps-mini {
  text-align: right;
  padding-right: 0;
  /* filter: brightness(0) saturate(100%) invert(15%) sepia(53%) saturate(1820%) hue-rotate(159deg) brightness(94%) contrast(91%); */
}

.icon-maps-mini {
  /* max-height: 75%;
    max-width: 100%; */
  max-width: fit-content;
  max-height: 3.5rem;
}

.margin-bottom-row-mini {
  margin-bottom: 1rem;
}

.png-image-dark-blue-lq {
  filter: brightness(0) saturate(100%) invert(15%) sepia(53%) saturate(1820%) hue-rotate(159deg) brightness(94%) contrast(91%);
}

.impact-wrapper {
  display: flex;
  justify-content: center;
  align-items: end;
  width: max-content;
  margin: 0 auto;
  padding-bottom: 0.5rem;
  column-gap: 7rem;
  row-gap: 0.5rem;
}

.impact-column {
  width: max-content;
  display: flex;
  flex-direction: column;
  row-gap: 0.5rem;
}

.text-impact-wrapper {
  width: 12rem;
}

.title-impact {
  font-size: 2rem;
  text-align: start;
}

.text-impact-desc {
  font-size: 0.8rem;
  text-align: start;
}

@media (min-width: 768px) {
  .impact-wrapper {
    padding-bottom: 1rem;
    row-gap: 1rem;
  }

  .impact-column {
    row-gap: 1rem;
  }

  .text-impact-wrapper {
    width: 15rem;
  }

  .title-impact {
    font-size: 3rem;
  }

  .text-impact-desc {
    font-size: 1rem;
  }

  .icon-users {
    height: 5rem;
  }
}

@media (min-width: 992px) {
  .impact-column {
    padding-bottom: 2rem;
    row-gap: 2rem;
  }
  .text-impact-wrapper.text-impact-qtv-wrapper {
    width: fit-content;
  }
}

</style>
